import React from 'react';
import './Title.css';

export default function Title(){
    return(<div className="TitleBar">Monitoring des services Ingéniance</div>)
}